import axios from 'axios';
import { useToast } from 'vue-toastification';

// ایجاد نمونه اصلی Axios
const apiClient = axios.create({
  baseURL: process.env.VUE_APP_BACKEND_URL,
  timeout: 100000, // زمان انتظار (در میلی‌ثانیه)
  headers: {
    'Content-Type': 'application/json', // نوع محتوای پیش‌فرض
  },
});
const toast = useToast();

// شمارنده درخواست‌های فعال
let activeRequests = 0;
let loadingMessage = null;

// افزودن توکن به درخواست‌ها (در صورت نیاز)
apiClient.interceptors.request.use(
  (config) => {
    // افزایش شمارنده درخواست‌ها
    activeRequests += 1;

    // نمایش پیام انتظار فقط برای اولین درخواست
    if (activeRequests === 1) {
      // loadingMessage = toast.info('در حال دریافت اطلاعات...', 0);
    }

    const token = localStorage.getItem("token"); // توکن از LocalStorage یا هر منبع دیگر
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    // کاهش شمارنده درخواست‌ها و حذف پیام انتظار در صورت بروز خطا
    activeRequests -= 1;
    if (activeRequests === 0 && loadingMessage) {
      loadingMessage();
    }
    return Promise.reject(error);
  }
);

// مدیریت پاسخ‌ها و خطاها
apiClient.interceptors.response.use(
  (response) => {
    // کاهش شمارنده درخواست‌ها
    activeRequests -= 1;

    // حذف پیام انتظار تنها زمانی که همه درخواست‌ها کامل شده باشند
    if (activeRequests === 0 && loadingMessage) {
      loadingMessage();
    }
    return response;
  },
  (error) => {
    // کاهش شمارنده درخواست‌ها
    activeRequests -= 1;

    // حذف پیام انتظار تنها زمانی که همه درخواست‌ها کامل شده باشند
    if (activeRequests === 0 && loadingMessage) {
      loadingMessage();
    }

    if (error.response && error.response.status === 401) {
      toast.error('عدم دسترسی: مجدد وارد شوید.');
      localStorage.removeItem("token");
      localStorage.removeItem("role");
      localStorage.removeItem("userInfo");
      // انتقال کاربر به صفحه لاگین (در صورت نیاز)
    }

    if (error.response && error.response.status === 404) {
      toast.error('داده ای یافت نشد.');
    }

    if (error.response && error.response.status === 500) {
      const errMsg = error.response.data.split('\r\n')[0].replace('System.Exception:', '');
      debugger
      toast.error(errMsg);
    }
    return Promise.reject(error);
  }
);

export default apiClient;
